<template>
  <h1>{{ $t('payment_result.failed') }}</h1>
</template>

<script>
export default {
  name: 'Fail',
};
</script>

<style scoped></style>
